import { render, staticRenderFns } from "./Art.vue?vue&type=template&id=ff3bc2b8&"
import script from "./Art.vue?vue&type=script&lang=js&"
export * from "./Art.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Art.vue"
export default component.exports